@switch (columnName) {
  @case ('dateTime') {
    <span class="highlighted-text">
      {{ element.date | date }}
    </span>
    <span class="text-secondary">
      {{ element.date | date: timeFormat }}
    </span>
  }
  @case ('date') {
    <span class="highlighted-text">
      {{ element.date | date }}
    </span>
    <span class="text-secondary">
      {{ element.date | date: timeFormat }}
    </span>
  }
  @case ('action') {
    {{ element.action | translate }}
  }
  @case ('actionDoneBy') {
    {{ element.createdBy }}
  }
  @case ('logChanges') {
    @if (fieldChangeRows.length > 0) {
      @for (change of fieldChangeRows; track $index) {
        <div class="field-change">
          <span class="highlighted-text">
            @if (change.labelKey) {
              {{ change.labelKey | translate }}
            } @else {
              {{ change.fieldName | translate }}
              {{ change.translationKey | translate }}
            }
          </span>
          <span class="text-secondary">
            @if (isDateField(change.fieldName)) {
              <app-text-overflow-label
                [text]="(change.value | date: dateTimeFormat) ?? change.value"
              ></app-text-overflow-label>
            } @else {
              <app-text-overflow-label [text]="change.value"></app-text-overflow-label>
            }
          </span>
        </div>
      }
    } @else {
      {{ getActionLabelDescriptionKey() | translate }}
    }
    @if (element.comment) {
      <div class="field-change">
        <span class="highlighted-text">{{ 'adminLogComment' | translate }} {{ ' ' }}</span>
        <span class="text-secondary">
          <app-text-overflow-label [text]="element.comment"></app-text-overflow-label>
        </span>
      </div>
    }
  }
}
